// ABOUTME: Layout component providing consistent page structure with navigation
// ABOUTME: Wraps page content with navigation bar and maintains responsive design

import React, { ReactNode } from 'react';
import { Navigation } from './Navigation';

interface LayoutProps {
  children: ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main>{children}</main>
    </div>
  );
};
